import { i18nStore } from "./store";
export const i18n = (node, params) => {
    let { id, data } = getIdAndDataFromParams(params);
    let unsubscriber = i18nStore.subscribe((manager) => {
        if (manager.isLoading)
            return;
        node.innerHTML = i18nStore.getTranslationFormatted(id, data);
    });
    return {
        update(params) {
            data = getIdAndDataFromParams(params).data;
            node.innerHTML = i18nStore.getTranslationFormatted(id, data);
        },
        destroy() {
            if (unsubscriber) {
                unsubscriber();
            }
        },
    };
};
export const i18nFormat = (node, params) => {
    const content = node.innerHTML;
    //TODO must check for complex formatting (plural, select, date, time etc...)
    const canSkipFormat = typeof (params) === "string" && content.indexOf('{') < 0;
    if (canSkipFormat) {
        return;
    }
    let { data } = getIdAndDataFromParams(params);
    let unsubscriber = i18nStore.subscribe((manager) => {
        node.innerHTML = i18nStore.getFormattedMessage(content, data);
    });
    return {
        update(params) {
            if (canSkipFormat) {
                return;
            }
            data = getIdAndDataFromParams(params).data;
            node.innerHTML = i18nStore.getFormattedMessage(content, data);
        },
        destroy() {
            if (unsubscriber) {
                unsubscriber();
            }
        },
    };
};
const getIdAndDataFromParams = (params) => {
    let id = typeof params === "string" ? params : params.id;
    let data = typeof params === "string" ? {} : params.data ? params.data : {};
    return { id, data };
};
//# sourceMappingURL=actions.js.map